<template>
  <div class="sub-header-wrap">
    <div class="sub-header-title">
      <h2>{{ route.matched[0].meta.breadcrumbName }}</h2>
      <h3>{{ route.matched[0].meta.description }}</h3>
    </div>
    <div class="sub-header-tab">
      <ul>
        <li
          v-for="(child, idx) in childMenu as Array<RouteRecordRaw>"
          :key="`${child.path}-${idx}`"
          :class="{
            on: route.name === child.name || child.name === route?.meta.subName,
          }"
        >
          <router-link
            v-if="child?.meta?.breadcrumbName"
            :class="{
              active:
                route.name === child.name || child.name === route?.meta.subName,
            }"
            :to="{ name: child.name }"
            >{{ child?.meta.breadcrumbName }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
import { RouteRecordRaw, useRoute } from 'vue-router';
import { computed } from 'vue';
import { useUserStore } from '@stores';

const userStore = useUserStore();
const route = useRoute();
const isAdmin = computed(() => userStore.grant === 'WEB_ADMIN');
const childMenu = computed(() =>
  route?.matched[0]?.children.filter((f) => {
    if (f?.meta?.isAdmin) {
      return isAdmin.value;
    } else {
      return f?.meta?.breadcrumb;
    }
  })
);
</script>

<style scoped lang="scss">
.sub-header-wrap {
  width: 100%;
  padding-top: 82px;
  position: relative;
}

.sub-header-title {
  width: 1280px;
  margin: auto;
}

.sub-header-title h2 {
  font-size: 40px;
  font-weight: bold;
  letter-spacing: -1px;
  padding-bottom: 18px;
}

.sub-header-title h3 {
  letter-spacing: -0.4px;
  color: #666;
  padding-bottom: 70px;
}

.sub-header-tab {
  width: 100%;
  position: relative;
  border-bottom: 1px solid #ddd;
}

.sub-header-tab ul {
  max-width: 1280px;
  margin: auto;
  display: flex;
  gap: 0 56px;
}

.sub-header-tab ul li {
  font-size: 20px;
  font-weight: 500;
  color: #222;
  position: relative;
  cursor: pointer;
}

.sub-header-tab ul li:hover,
.sub-header-tab ul li.on {
  color: var(--color-main);
  font-weight: bold;
}

.sub-header-tab ul li:hover::after,
.sub-header-tab ul li.on::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 4px;
  background-color: var(--color-main);
}

.sub-header-tab ul li a {
  display: block;
  padding-bottom: 23px;
}
</style>
